<template lang="html">
  <div class="sm-order" v-show="orderOptions.isOrderShow">

    <!-- 购买失败 start -->
    <div class="sm-order-content success fail" v-if="ifFail">
      <i class="bk-icon icon-close" @click="closeSuccess"></i>
      <div class="bk-message-box">
        <i class="bk-icon icon-fail"></i>
        <p class="message big">兑换商品出现错误 </p>
        <p class="message small">请联系<a href="//wpa.b.qq.com/cgi/wpa.php?ln=1&amp;key=XzgwMDgwMjAwMV80NDMwOTZfODAwODAyMDAxXzJf" target="_blank">官方客服</a>反馈该问题</p>
        <a class="bk-text-button bk-primary" title="继续购买" href="javascript:" style="padding-top: 8px;" @click="closeSuccess">继续购买 »</a>
      </div>
    </div>
    <!-- 购买失败 end -->

    <!-- 购买成功 start -->
    <div class="sm-order-content success" v-if="ifSuccess">
      <i class="bk-icon icon-close" @click="closeSuccess"></i>
      <div class="bk-message-box">
        <i class="bk-icon icon-success"></i>
        <p class="message big">购买成功 {{shopDetail.title}}</p>
        <p class="message default">订单号码： {{order_id}}</p>
        <p class="message small">需要邮寄的物品，将在3个工作日内审核通过并在订单详情中提供邮寄单号，请注意查收！</p>
        <a class="bk-text-button bk-primary" title="继续购买" href="javascript:" style="padding-top: 8px;" @click="closeSuccess">继续购买 »</a>
      </div>
    </div>
    <!-- 购买成功 end -->

    <!-- 鲸币商城订单 start -->
    <div :class="['sm-order-content',{'opacity':opacity}]" v-if="!ifFail && !ifSuccess">
      <i class="bk-icon icon-close" @click="closeOrder"></i>
      <div class="sm-order-overflow">
        <div class="sm-order-white"></div>
        <div class="sm-order-shop">
          <!-- 轮播图 start -->
          <div class="sm-order-slide">
            <div class="sm-goods-picture">
              <img :src="shopDetail.logo_list[0]" alt="" v-if="curImgIndex === '0' && shopDetail.logo_list">   <!-- 默认选中第一个小图 -->
              <img :src="curImgUrl" alt="" v-else>
            </div>
            <div class="sm-goods-list">
              <a href="javascript:" :class="['bk-icon icon-left',{'not-allow':firstIndex==0}]" @click="slideLeft"></a>
              <div class="sm-goods-small">
                <transition-group name="list" class="sm-goods-box" tag="ul">
                  <li
                    :class="['sm-goods',{'active':index == curImgIndex}]"
                    v-for="(item,index) in shopDetail.logo_list"
                    v-show="index >= firstIndex && index <= lastIndex"
                    :key="item"
                    @click="chooseImg(item,index)"
                  >
                    <img :src="item" alt="">
                  </li>
                </transition-group>
              </div>
              <a href="javascript:" :class="['bk-icon icon-right',{'not-allow':lastIndex==slideLength-1}]" @click="slideRight"></a>
            </div>
          </div>
          <!-- 轮播图 end -->
          <!-- 商品信息 start -->
          <div class="sm-order-message">
            <div class="sm-order-div" style="margin-bottom: 5px">
              <label>商品名称：</label>
              <div class="sm-order-item">
                <span class="bold">{{shopDetail.title}}</span>
              </div>
            </div>
            <div class="sm-order-div" style="margin-bottom: 5px">
              <label>价格：</label>
              <div class="sm-order-item">
                <div class="shop-list-money">
                  {{checkResult.price}}
                </div>
                <span class="deduct-expenses" v-if="(priceComputeResult && !failCode)">即将扣除鲸币：{{priceComputeResult}}</span>
                <span class="is-danger pl5" v-show="failCode == '40002'">{{failMessage}}</span>
              </div>
            </div>
            <div class="sm-order-div" style="margin-bottom: 5px">
              <label>库存：</label>
              <div class="sm-order-item">
                {{checkResult.amount}}<span class="is-danger pl5" v-show="failCode == '40001'">{{failMessage}}</span>
              </div>
            </div>
            <div class="sm-order-div" v-for="(oitem,oindex) in shopDetail.options" v-if="shopDetail.options">
              <label>{{oitem.text}}：</label>
              <div class="sm-order-item">
                <label :class="['bk-form-radio',{'no-stock':noStock}]" v-for="(kitem,kindex) in oitem.data">
                  <input type="radio" :name="oitem.text" :value="kitem" v-model="option[oindex]">
                  <i class="bk-button bk-default bk-radio-text" :title="kitem">
                    <span>{{kitem}}</span>
                  </i>
                </label>
              </div>
            </div>
            <div class="sm-order-div">
              <label>说明：</label>
              <div class="sm-order-item">
                <span class="sm-order-dec">{{shopDetail.desc}}</span>
              </div>
            </div>
          </div>
          <!-- 商品信息 end -->
        </div>
        <!-- <div class="shop-content" v-if="shopDetail.is_virtual">
          <div class="sm-order-div" v-if="shopDetail.is_virtual">
            <label class="bk-label">&nbsp;</label>
              <div class="bk-form-content">
                <a :class="['bk-button bk-primary',{'is-disabled':failCode!==''}]" title="确定购买" style="width: 98px; position: relative" @click='buy()'>
                  <span>确定购买</span>
                </a>
                <a class="bk-button" title="取消" style="width: 98px" @click="closeOrder()">
                  <span>取消</span>
                </a>
              </div>
          </div>
        </div> -->
        <div :class="['shop-content', {'virtual': shopDetail.is_virtual}]">
          <form class="bk-form">
            <h2>订单信息</h2>
            <div class="bk-form-item">
              <label class="bk-label">收件人：</label>
              <div class="bk-form-content">
                <input
                  type="text"
                  :class="['bk-form-input',{'is-danger':isRecipientNull}]"
                  name="validation_name"
                  style="width: 305px"
                  v-model="recipient"
                  @click="onFocusRecipient"
                  @blur="checkRecipient"
                >
                <span class="bk-form-tip recipientTips" v-if="isRecipientNull === true"><span class="tip">{{info.recipientTips}}</span></span>
              </div>
            </div>
            <div class="bk-form-item">
              <label class="bk-label">所在地区：</label>
              <div class="bk-form-content">
                <div class="select-group">
                  <select class="bk-form-select">
                    <option>中国大陆</option>
                  </select>
                  <select
                    :class="['bk-form-select',{'selected':info.province != -1,'initialize':info.province == -1,'is-danger':info.isProviceNull == true && info.province == -1}]"
                    v-model="info.province"
                    @change="updateMap('province')"
                  >
                    <option value="-1" hidden>请选择省</option>
                    <template v-if="info.provinceList.length > 0">
                      <option v-for="item in info.provinceList" :value="item.provinceID">{{ item.province }}</option>
                    </template>
                    <option v-else>暂无数据</option>
                  </select>
                  <!-- <span>省</span> -->
                  <!-- 省 -->
                  <select
                    :class="['bk-form-select',{'selected':info.city != -1,'initialize':info.city == -1,'is-danger':info.isCityNull == true && info.city == -1}]"
                    v-model="info.city"
                    :disabled="info.province === '-1'"
                    @change="updateMap('city')"
                  >
                    <option value="-1" hidden>请选择市</option>
                    <template v-if="info.cityList.length > 0">
                      <option v-for="item in info.cityList" :value="item.cityID">{{ item.city }}</option>
                    </template>
                    <option v-else>暂无数据</option>
                  </select>
                  <!-- <span>市</span> -->
                  <!-- 市 -->
                  <select
                    :class="['bk-form-select',{'selected':info.district != -1,'initialize':info.district == -1,'is-danger':info.isDistrictNull == true && info.district == -1}]"
                    v-model="info.district"
                    :disabled="info.city === '-1'"
                    @change="updateMap('district')"
                  >
                    <option value="-1" hidden>请选择地区</option>
                    <template v-if="info.districtList.length > 0">
                      <option v-for="item in info.districtList" :value="item.areaID">{{ item.area }}</option>
                    </template>
                    <option v-if="info.districtList.length == 0" >全市</option>
                  </select>
                  <!-- <span>镇/区</span> -->
                  <!-- 镇/区 -->
                </div>
                <div class="select-group is-danger" style="padding-left: 130px; padding-top: 5px; font-size: 12px" v-show="isCannot">很抱歉，目前邮件地址暂不支持内蒙古和新疆地区，还请谅解！</div>
              </div>
            </div>
            <div class="bk-form-item">
              <label class="bk-label">详细地址：</label>
              <div class="bk-form-content">
                <textarea
                  :class="['bk-form-textarea',{'is-danger':isAddressNull}]"
                  style="width: 486px"
                  v-model="info.detail"
                  @click="onFocusAddress"
                  @blur="updateMap(),checkValidate()"
                  placeholder="请输入详细地址"
                >
                </textarea>
                <span class="bk-form-tip addressDetailTip" v-if="isAddressNull === true"><span class="tip">{{info.tips}}</span></span>
              </div>
            </div>
            <div class="bk-form-item">
              <label class="bk-label">手机号码：</label>
              <div class="bk-form-content">
                <span class="bk-form-panel">
                  <select name="validation_select" class="bk-form-select" style="width: 132px">
                    <option value="beijing">中国大陆 +86</option>
                  </select>
                </span>
                <input
                  type="text"
                  :class="['bk-form-input',{'is-danger':isPhoneNull}]"
                  style="width: 163px"
                  v-model='phoneNumber'
                  @blur="checkPhoneNumber"
                  @click="onFocusPhone"
                >
                <span class="bk-form-tip" v-if="isPhoneNull === true">{{info.phoneTips}}</span>
              </div>
            </div>
            <div class="bk-form-item bk-form-action">
              <label class="bk-label" v-if="!shopDetail.is_virtual">&nbsp;</label>
              <div class="bk-form-content">
                <a :class="['bk-button bk-primary',{'is-disabled':failCode!==''}]" title="确定购买" style="width: 98px; position: relative" @click='buy()'>
                  <span>确定购买</span>
                  <!-- <span v-if="isBuyLoading" style="position: absolute; left: 50%; top: 50%; transform: translate3d(-50%,-50%,0)"><img src="../images/common/loading_2_24x24.gif" alt="" /></span> -->
                </a>
                <a class="bk-button" title="取消" style="width: 98px" @click="closeOrder()">
                  <span>取消</span>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- 鲸币商城订单 end -->

    <!-- 弹窗组件 -->
    <v-transaction :showTradePassword="showTradePassword" @after-check="afterCheck" @close-box="closeBox"></v-transaction>

    <v-alert :options="v_options"></v-alert>

  </div>
</template>

<script>
import vAlert from './alert.vue';
import vTransaction from './transaction.vue';
export default {
    components: {
        'v-alert': vAlert,
        'v-transaction': vTransaction
    },
    data () {
        return {
            v_options: {
                msgText: '',
                msgIsSuccess: true
            },
            isPhoneNull: false,
            phoneNumber: '',
            isAddressNull: false,
            address: '',
            isRecipientNull: false,
            recipient: '',
            ifSuccess: false,
            ifFail: false,
            result: null,
	    show: true,
            info: { // 帐号信息对象
                province: '-1',
                city: '-1',
                district: '-1',
                detail: '',
                tips: '请输入详细地址',
                recipientTips: '请输入收件人',
                phoneTips: '请输入11位手机号码',
                provinceList: [],
                cityList: [],
                districtList: [],
                isProviceNull: false,
                isCityNull: false,
                isDistrictNull: false
            },
            priceComputeResult: '', // 鲸币计算结果
            option: [],
            curImgIndex: '0',
            curImgUrl: '',
            firstIndex: '0',
            lastIndex: '3',
            slideLength: '',
            order_id: '',
            failMessage: '',
            failCode: '',
            myJson: {},
            checkResult: {
                amount: '0',
                price: '0.00'
            },
            noStock: false,
            trade_password: {
                status: true,
                password: '',
                message: ''
            },
            showTradePassword: false,
            opacity: false,
            districtFull: true,
            isCannot: false
        };
    },

    props: ['orderOptions', 'shopDetail', 'bkb'],
    mounted () {
        this.getData();

    },
    methods: {
        closeTradePassword () {
            this.showTradePassword = false;
            this.opacity = false;
            this.trade_password.message = '';
            this.trade_password.status = true;
            this.trade_password.password = '';
        },
        getData () {
            axios.all([this._getProvinces()])
                .then(axios.spread((provinces) => {
                    this._setProvinces(provinces);
                }));
        },
        // 点击小图
        chooseImg (item, index) {
            this.curImgIndex = index;
            this.curImgUrl = item;
        },
        // 点击向左按钮
        slideLeft () {
            if (this.firstIndex > 0) {
                this.firstIndex--;
                this.lastIndex--;
            }
            else {
                this.firstIndex = 0;
                this.lastIndex = 3;
            }
        },
        // 点击向右按钮
        slideRight () {
            if (this.lastIndex < this.shopDetail.options.logo.length - 1) {
                this.firstIndex++;
                this.lastIndex++;
            }
            else {
                // this.firstIndex = this.shopDetail.options.logo.length-3
                // this.lastIndex = this.shopDetail.options.logo.length-1
            }
        },
        /*
     ** 获取省份信息
     */
        _getProvinces () {
            return axios.post(myUrl + 'misc/province/');
        },
        /*
     ** 获取省份信息后的回调函数
     */
        _setProvinces (response) {
            // console.log(response)
            let res = response.data;

            if (res.result) {
                this.info.provinceList = res.data;
                return true;
            }
            else {
                console.log(res.message);
                return false;
            }
        },
        /*
     ** 根据省份获取城市信息
     */
        _getCities (code) {
            if (code == '150000' || code == '650000') { // 选择内蒙古和新疆地区
                this.isCannot = true;
            }
            else {
                this.isCannot = false;
            }
            return axios.post(myUrl + 'misc/city/v3/' + code + '/');
        },
        /*
     ** 渲染城市列表
     */
        _setCities (response) {
            let res = response.data;

            if (res.result) {
                this.info.cityList = res.data;
                return true;
            }
            else {
                console.log(res.message);
                return false;
            }
        },
        /*
     ** 根据城市获取区信息
     */
        _getDistricts (code) {
            return axios.post(myUrl + 'misc/area/v3/' + code + '/');
        },
        /*
     ** 渲染区列表
     */
        _setDistricts (response) {
            let res = response.data;

            if (res.result) {
                this.info.districtList = res.data;
                return true;
            }
            else {
                console.log(res.message);
                return false;
            }
        },
        /*
     ** 合并地址
     */
        _jointAddress () {
            let info = this.info,
                addr = info;

            let province = '',
                city = '',
                district = '';

            for (let p of info.provinceList) {
                if (p.provinceID == addr.province) {
                    province = p.province;
                    break;
                }
            }

            for (let c of info.cityList) {
                if (c.cityID == addr.city) {
                    city = c.city;
                    break;
                }
            }

            for (let d of info.districtList) {
                if (d.areaID == addr.district) {
                    district = d.area;
                    break;
                }
                else {
                    district = '';
                }
            }

            this.completedAddress = province + city + district + addr.detail;
        },
        /*
     ** 更新地图
     */
        updateMap (type) {
            this._jointAddress();
            let addr = this.info;
            this.goTrack('', false, 'user-center-mallorder-2');

            switch (type) {
                case 'province':
                    axios.all([this._getCities(addr.province)]).then(axios.spread((cities) => {
                        this._setCities(cities);
                        this.info.districtList = [];
                        this.info.city = '-1';
                        this.info.district = '-1';
                    }));
                    break;
                case 'city':
                    axios.all([this._getDistricts(addr.city)]).then(axios.spread((districts) => {
                        this._setDistricts(districts);
                        this.info.district = '-1';
                    }));
                    break;
            }
        },

        areaResult: function (show, result) {
  		this.show = show;
  		this.result = result;
  	},
        closeOrder () {
            // 关闭对话框重置参数
            this.firstIndex = 0;
            this.lastIndex = 3;
            this.curImgIndex = this.checkResult.amount = '0';
            this.checkResult.price = '0.00';

            this.showTradePassword =
      this.opacity =
      this.orderOptions.isOrderShow =
      this.isPhoneNull =
      this.isAddressNull =
      this.isRecipientNull =
      this.info.isProviceNull =
      this.info.isCityNull =
      this.info.isDistrictNull =
      this.ifFail =
      this.ifSuccess =
      this.isCannot = false;

            this.trade_password.message =
      this.trade_password.password =
      this.phoneNumber =
      this.address =
      this.recipient =
      this.info.detail =
      this.failMessage =
      this.failCode = '';

            this.info.province =
      this.info.city =
      this.info.district = '-1';

            this.option = [];
            this.myJson = {};

            this.trade_password.status = true;

            this.$emit('changeData');
        },
        // 点击购买
        buy () {
            if (this.shopDetail.is_virtual) {
                this.beforeCheck(this.myJson);
                if (this.checkResult.amount !== 0) {
                    this.ifTradePassword();
                }
            } else {
                if (this.failCode === '' || this.failCode === null) {
                    this.checkLevel();
                    this.checkPhoneNumber();
                    this.checkRecipient();
                    this.checkValidate();
                    if (!this.info.isProviceNull && !this.info.isCityNull && !this.info.isDistrictNull && !this.isPhoneNull && !this.isRecipientNull && !this.isAddressNull) {
                        this.beforeCheck(this.myJson);
                        this.ifTradePassword();
                    }
                }
            }
        },
        // 检查库存及数量
        beforeCheck (formData) {
            axios.post(myUrl + 'market/gift/check/', qs.stringify(formData))
                .then((res) => {
                    let resData = res.data;

                    if (resData.result) {
                        this.checkResult.amount = resData.data.amount;
                        this.checkResult.price = resData.data.price;
                        this.failMessage = '';
                        this.failCode = '';
                        if (parseInt(this.checkResult.price) > parseInt(this.bkb.bkb)) {
                            this.failMessage = '您的鲸币不足以购买该商品';
                            this.failCode = '40002';
                        }
                        else if (parseInt(this.checkResult.amount) === 0) {
                            this.failMessage = '该商品库存不足，无法购买';
                            this.failCode = '40001';
                        } else {
                            const price = this.checkResult.price;
                            const { common_bkb, share_bkb, professional_bkb } = this.bkb;
                            const bkbList = [parseInt(common_bkb), parseInt(share_bkb), parseInt(professional_bkb)];
                            const result = [];
                            this.computePrice(result, price, bkbList);
                            const type = ['普通', '分享', '专业'];
                            result.forEach((item, index) => {
                                this.priceComputeResult += type[index] + item + (result.length - 1 === index ? '' : '、');
                            });
                        }
                    }
                    else {
                        this.checkResult.amount = '0';
                        this.failMessage = '该商品库存不足，无法购买';
                        // this.failMessage = resData.message.replace(/\s[\x00-\xff]*/g,'');
                        this.failCode = resData.code;
                    }
                });
        },
        // 计算扣除鲸币
        computePrice (result, price, bkbList, index = 0) {
            if (bkbList[index] - price < 0) {
                result[index] = parseInt(bkbList[index]);
                const curPrice = -(bkbList[index] - price);
                this.computePrice(result, curPrice, bkbList, ++index);
            } else {
                result[index] = price;
            }
        },
        // 检测是否设置交易密码
        ifTradePassword () {
            axios.post(myUrl + 'profile/user/safe/')
                .then((res) => {
                    let resData = res.data;
                    if (resData.result) {
                        if (resData.data[1].status) { // 设置了交易密码
                            this.showTradePassword = true;
                            this.opacity = true;
                        }
                        else {
                            this.v_options = {
                                msgText: '购买失败，您还未设置交易密码',
                                msgIsSuccess: false
                            };
                        }
                    }
                    else {
                        console.log(resData.message);
                    }
                });
        },
        // 检测交易密码是否正确
        // checkTradePassword (pwd) {
        //
        //   if (pwd == '' || pwd == null) {
        //     // this.trade_password.status = false;
        //     // this.trade_password.message = '交易密码不能为空！';
        //   }
        //   else {
        //     axios.post(myUrl + "market/gift/check_trade_password/",qs.stringify({
        //       'trade_password': pwd
        //     }))
        //     .then((res) => {
        //       let resData = res.data;
        //       if(resData.result) {
        //         this.showTradePassword = false;
        //         this.afterCheck(this.myJson,pwd);
        //       }
        //       else{
        //         console.log(resData.message)
        //       }
        //     })
        //   }
        // },
        // 购买
        afterCheck (val) {

            let formData = this.myJson;
            let address = {
                'address': this.completedAddress,
                'telephone': this.phoneNumber,
                'name': this.recipient
            };
            formData['address'] = JSON.stringify(address);
            formData['note'] = '';
            formData['trade_password'] = val;

            axios.post(myUrl + 'market/gift/buy/', qs.stringify(formData))
                .then((res) => {
                    let resData = res.data;
                    this.showTradePassword = false;
                    if (resData.result) {
                        this.ifSuccess = true;
                        this.order_id = resData.data.order_id;
                        this.$emit('changeMoney', this.checkResult.price);
                        this.goTrack('', false, 'user-center-mall-order-submit');
                    }
                    else {
                        this.ifFail = true;
                    }
                });
        },
        closeBox () {
            // this.orderOptions.isOrderShow = false;
            this.showTradePassword = false;
            this.opacity = false;
        },
        // 校验手机号码
        checkPhoneNumber () {
            if (this.phoneNumber == '' || this.phoneNumber == null) {
                this.isPhoneNull = true;
                this.info.phoneTips = '请输入11位手机号码';
            }
            else if (!(/^1[3456789]\d{9}$/.test(this.phoneNumber)) && this.phoneNumber != '') {
                this.isPhoneNull = true;
                this.info.phoneTips = '手机号码格式有误';
            }
        },
        // 校验收件人
        checkRecipient () {
            if (this.recipient == '' || this.recipient == null) {
                this.isRecipientNull = true;
                this.info.recipientTips = '请输入收件人';
            }
            else if (!(/^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\.\s]{1,20})$/.test(this.recipient))) {
                this.isRecipientNull = true;
                this.info.recipientTips = '请输入正确的收件人姓名';
            }
            else {
                this.isRecipientNull = false;
            }
        },
        // 校验地址正确性
        checkValidate () {
            if (this.info.detail == '' || this.info.detail == null) {
                this.info.tips = '请输入详细地址';
                this.isAddressNull = true;
            }
            else if (!(/([^\x00-\xff]|[A-Za-z0-9_])+/.test(this.info.detail))) {
                this.info.tips = '请输入合法地址';
                this.isAddressNull = true;
            }
        },
        // 校验地级正确性
        checkLevel () {
            if (this.info.province == '-1') {
                this.info.isProviceNull = true;
            }
            else if (this.info.province != '-1') {
                this.info.isProviceNull = false;
            }
            if (this.info.city == '-1') {
                this.info.isCityNull = true;
            }
            else if (this.info.city != '-1') {
                this.info.isCityNull = false;
            }
            if (this.info.district == '-1') {
                this.info.isDistrictNull = true;
            }
            else if (this.info.district != '-1') {
                this.info.isDistrictNull = false;
            }

            // if (this.info.districtList.length == 0) {
            //   // this.districtFull = false;
            //   this.info.district = '0';
            //   this.info.isDistrictNull = false;
            // }
        },
        /*
     ** 百度统计
     */
        goTrack (url, status, action) {
            _hmt.push(['_trackPageview', url]);
            _hmt.push(['_trackEvent', action, 'click']);
            console.log(action);
            if (status) {
                this.$router.push({
                    path: url
                });
            }
        },
        onFocusAddress () {
            this.isAddressNull = false;
            this.goTrack('', false, 'user-center-mallorder-3');
        },
        onFocusPhone () {
            this.isPhoneNull = false;
            this.goTrack('', false, 'user-center-mallorder-4');
        },
        onFocusRecipient () {
            this.isRecipientNull = false;
            this.goTrack('', false, 'user-center-mallorder-1');
        },
        onFocusPassword () {
            this.trade_password.status = true;
            this.trade_password.message = '';
        },
        closeSuccess () {
            this.ifSuccess = false;
            this.closeOrder();
        },
        myJsonTo () {
            var json = {};
            json['gift'] = this.shopDetail.id.toString();
            for (var i = 0; i < this.option.length; i++) {
                json['option' + (i + 1)] = this.option[i];
            }
            this.myJson = json;
        }
    },

    watch: {

        shopDetail () {
            this.slideLength = this.shopDetail.logo_list.length;
            if (this.slideLength <= 3) {
                this.lastIndex = this.slideLength - 1;
            }
            else {
                this.lastIndex = 3;
            }
            this.priceComputeResult = '';
        },
        // 默认选中第一个radio
        'shopDetail.options' () {
            for (var i = 0; i < this.shopDetail.options.length; i++) {
                this.option[i] = this.shopDetail.options[i].data[0];
            }
            this.myJsonTo();
            this.beforeCheck(this.myJson);
        },
        option () {
            this.priceComputeResult = '';
            this.myJsonTo();
            this.beforeCheck(this.myJson);
        }

    }
};
</script>

<style lang="scss" scoped>
  .sm-order {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
    &-content {
      position: relative;
      background: #ffffff;
      border-radius: 2px;
      overflow: hidden;
      width: 814px;
      min-height: 488px;
      max-height: 754px;
      position: absolute;
      left: 50%;
      top: 50%;
      // margin: -390px 0 0 -407px;
      -moz-transform: translate3d(-50%,-50%,0);
      -ms-transform: translate3d(-50%,-50%,0);
      -o-transform: translate3d(-50%,-50%,0);
      -webkit-transform: translate3d(-50%,-50%,0);
      transform: translate3d(-50%,-50%,0);
      z-index: 1001;

      &.success {
        height: 480px;
        padding: 30px;
        .bk-message-box {
          width: 754px;
          height: 420px;
          text-align: center;
          display: table-cell;
          vertical-align: middle;
          .icon-success {
            width: 58px;
            height: 58px;
            background-size: cover;
            background: url(../images/personal_center/icon-success.png) no-repeat;
          }
          .icon-fail {
            width: 58px;
            height: 58px;
            background: url(../images/personal_center/icon-fail.png) no-repeat;
            background-size: cover;
          }
          .message {
            color: #444444;
            font-size: 12px;
            &.big {
              font-size: 22px;
              line-height: 30px;
              padding: 20px 0 10px;
            }
            &.default {
              padding: 12px 0;
            }
            &.small {
              color: #aaaaaa;
              padding: 12px 0;
              a {
                display: inline-block;
                padding: 0 5px;
              }
            }
          }
        }
      }
    }
    &-shop {
      width: 100%;
      height: 350px;
      padding: 54px 30px 30px 44px;
      background: #ffffff;
    }
    &-slide {
      width: 260px;
      border: solid 1px #eaeaea;
      height: 250px;
      display: inline-block;
      float: left;
      .sm-goods-picture {
        width: 258px;
        height: 196px;
        background: #f4f4f4;
        border-bottom: solid 1px #cfcfd1;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .sm-goods-list {
        font-size: 0;
        padding: 8px 21px;
        position: relative;
        .sm-goods-small {
          width: 216px;
          overflow: hidden;
          white-space: nowrap;
          .sm-goods-box {
            width: 100%;
            height: 100%;
            display: block;
            position: relative;
            overflow: hidden;
          }
        }
        .sm-goods {
          width: 48px;
          height: 35px;
          border: solid 1px #eaeaea;
          background: #eaeaea;
          display: inline-block;
          margin: 0 8px 0 0;
          font-size: 18px;
          img {
            width: 46px;
            height: 33px;
          }
          &.active {
            border: solid 1px #57a3f1;
          }
        }
      }
      .icon-left{
        position: absolute;
        left: 9px;
        top: 19px;
        width: 8px;
        height: 14px;
        background: url(../images/personal_center/icon-left.png) no-repeat;
        &.not-allow {
          background: url(../images/personal_center/icon-left3.png) no-repeat;
        }
      }
      .icon-right{
        position: absolute;
        right: 9px;
        top: 19px;
        width: 8px;
        height: 14px;
        background: url(../images/personal_center/icon-right.png) no-repeat;
        &.not-allow {
          background: url(../images/personal_center/icon-right3.png) no-repeat;
        }
      }
    }
    &-message {
      width: 470px;
      margin-left: 10px;
      display: inline-block;
      line-height: 32px;
      .sm-order-div{
        margin: 0 0 15px 0;
        // line-height: 20px;
      }
      label {
        text-align: right;
        width: 100px;
        display: inline-block;
        margin-right: 15px;
        float: left;
        // margin: 5px 15px 5px;
        &.bk-form-radio {
          width:  auto;
          margin-left: -10px;
          margin-bottom: 10px;
          // margin-left: 0;
          position: relative;
          &.no-stock {
            .bk-button {
              cursor: not-allowed;
              background-color: #fafafa !important;
              border: dashed 1px #e6e6e6 !important;
              color: #cccccc !important;
            }
          }
          .bk-button {
            margin-right: 0;
          }
        }
      }
    }
    &-item {
      display: inline-block;
      max-width: 330px;
      margin-bottom: -20px;
      .sm-order-dec {
        display: inline-block;
        line-height: 22px !important;
        padding: 5px 0;
        max-width: 335px;
        max-height: 54px;
        overflow: hidden;
      }
      .bold {
        font-weight: bold
      }
    }
  }
  .icon-close {
    position: absolute;
    top: 19px;
    right: 19px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    background: url(../images/personal_center/pops-close.png) no-repeat;
  }
  .shop-list-money {
    padding: 0 10px 0 25px;
    background: #eaeaea;
    border-radius: 10px;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    position: relative;
    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 8px;
      top: 5px;
      width: 14px;
      height: 14px;
      background: url(../images/personal_center/icon-money2.png);
    }
  }
  .deduct-expenses {
    margin-left: 10px;
    color:#53b821;
  }
  .bk-button {
    margin: 0 10px 0 0;
    font-style: normal;
    &.bk-default {
      padding: 0 10px;
      height: 32px;
      line-height: 30px;
    }
  }
  .icon-color {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    position: relative;
    top: 2px;
    &.red {
      background: #c74f0d;
    }
  }
  .shop-content {
    padding: 30px 25px 60px 45px;
    border-top: solid 1px #f4f4f4;
    background: #fafafa;
    h2{
      padding-left: 15px;
      line-height: 18px;
      height: 18px;
      font-size: 14px;
      color: #4f515e;
      position: relative;
      &:before {
        content: "";
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 18px;
        background: #57a3f1;
      }
    }
    &.virtual{
      padding-top: 0;
      padding-bottom: 0;
      h2{
        display: none;
      }
      .bk-form-item{
        display: none;
        &.bk-form-action{
          display: block;
          margin: 50px auto;
          text-align: center;
        }
      }
    }
  }
  .is-danger {
    color: #ff5656;
    display: inline-block;
  }
  .pl5 {
    padding-left: 5px;
  }
  .bk-form {
    width: 744px;
    margin: 0;
    .bk-form-item {
      position: relative;
      margin-top: 15px;
      text-align: left;
      &.bk-form-action {
        margin-top: 32px;
      }
    }
    .bk-label {
      color: #4f515e;
    }
    span {
      display: inline-block;
      margin-right: 5px;
    }
    .bk-form-item input.is-danger,
    .bk-form-item select.is-danger,
    .bk-form-item textarea.is-danger {
      border: 1px solid #ff5656;;
      background-color: #fff4f4;
      color: #ff5656;
    }
    .bk-form-tip {
      display: inline-block;
      color: #ff5656;
      padding-left: 5px;
      &.addressDetailTip {
        width: 125px;
        margin: 0 !important;
        float: right;
        height: 60px;
        .tip {
          display: table-cell;
          height: 60px;
          vertical-align: middle;
        }
      }
      &.recipientTips {
        max-width: 200px;
        margin: 0 !important;
        display: inline-block;
      }
    }
  }
  .bk-form-select {
    display: inline-block;
    width: auto;
  }
  .bk-form-radio {
    padding: 0 !important;
  }
  .bk-form-radio input[type=radio] {
    width: 0;
    height: 0;
  }
  .bk-form-radio input[type=radio]:checked + i.bk-button {
    border: solid 1px #57a3f1;
    background: #eef6fe;
  }
  .bk-form .bk-form-content > .bk-form-tip {
    margin-top: 0;
  }
  .bk-button.is-disabled, .bk-button[disabled] {
    background-color: #fafafa !important;
    border-color: #e6e6e6 !important;
    color: #cccccc !important;
    cursor: not-allowed !important;
  }
  .opacity {
    display: none;
  }
  .dialog-position {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 999;
    .dialog {
      width: 710px;
      height: 300px;
      background: #ffffff;
      position: fixed;
      left: 50%;
      top: 50%;
      z-index: 10000;
      border-radius: 5px;
      margin: -150px 0 0 -355px;
      padding: 70px;
    }
  }
  .bk-button.bk-success {
    background: #30d878;
    border-color: #30d878;
    color: #fff;
  }
  .is-danger {
    border-color: #ff5656 !important;
    &-span {
      display: none;
    }
    &-text {
      display: inline-block;
      color: #ff5656 !important;
    }
  }
  .icon-right-password {
    position: relative;
    right: 25px;
    width: 12px;
    height: 9px;
    background: url(../images/personal_center/icon-right2.png) no-repeat;
  }
  @media screen and (max-width:1440px)  {
    .sm-order-overflow {
      margin: 30px 0;
      height: 440px;
      overflow-y: auto;
    }
    .sm-order-white {
      height: 30px;
      position: absolute;
      background: #ffffff;
      width: 100%;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .sm-order-shop {
      padding-top: 24px;
    }
    .shop-content {
      padding-bottom: 30px;
    }
    .sm-order-content {
      height: 500px;
      overflow-y: auto;
      background: #fafafa;
      -webkit-transform: translate3d(-50%,0,0);
      -moz-transform: translate3d(-50%,0,0);
      -ms-transform: translate3d(-50%,0,0);
      -o-transform: translate3d(-50%,0,0);
      transform: translate3d(-50%,0,0);
      margin-top: -220px;
    }
    .sm-order-message {
      width: 450px;
    }
    .sm-order-content .icon-close {
      right: 29px;
    }
  }
  /* // @media screen and (max-width:1366px) {
  //   .sm-order-content {
  //     height: 570px;
  //     transform: translate3d(-50%,0,0);
  //     top: 72px;
  //     font-size: 12px;
  //   }
  //   .sm-order-shop {
  //     padding: 20px 30px 15px 44px;
  //   }
  //   .bk-form .bk-form-item,
  //   .bk-form .bk-form-item.bk-form-action {
  //     margin-top: 10px;
  //   }
  //   .shop-content {
  //       padding: 10px 45px 15px;
  //   }
  //   .sm-order-message .sm-order-div {
  //     margin-bottom: 10px;
  //   }
  //   .bk-button.bk-default {
  //     line-height: 24px;
  //     height: 26px;
  //   }
  //   .sm-order-message {
  //     line-height: 26px;
  //   }
  //   .sm-order-shop {
  //     height: 285px;
  //   }
  //   .bk-form-input, .bk-form-password, .bk-form-select, .bk-form-textarea {
  //     line-height: 30px;
  //   }
  //   .bk-form .bk-label {
  //     padding: 7px 16px 7px 0;
  //   }
  //   .shop-list-money,
  //   .bk-button,
  //   .bk-form .bk-label,
  //   .bk-form-input, .bk-form-password, .bk-form-select, .bk-form-textarea {
  //     font-size: 12px;
  //   }
  //   .bk-form-textarea {
  //     padding: 2px 10px;
  //   }
  // } */
  .icon-close:before {
    content: " "
  }
</style>



// WEBPACK FOOTER //
// order.vue?69b56404